import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=413272c2&scoped=true"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"
import style0 from "./invoices.vue?vue&type=style&index=0&id=413272c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413272c2",
  null
  
)

export default component.exports